<header *ngIf="router.url=='/123'">
  <div class="container">
    <nav class="navbar navbar-expand-lg navbar-light justify-content-between">
      <a class="navbar-brand" href="#"
        ><img src="../assets/Images/logo.jpg" class="img-fluid"
      /></a>
      <div class="d-block d-lg-none" *ngIf="authenticationService.currentUser| async ">
        <div class="dropdown show d-inline">
          <a
            class=""
            href="#"
            role="button"
            id="dropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa fa-user mr-3" aria-hidden="true"></i>
          </a>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a class="dropdown-item fs-12" href="#">{{ currentUser.name }}</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item fs-12" [routerLink]="['/profile/mydetail']"
              >Profile</a
            >
            <!-- <a class="dropdown-item fs-12" href="#">News</a> -->
            <a class="dropdown-item fs-12" (click)="logout()" href="#"
              >Logout</a
            >
          </div>
        </div>
        
        <!-- <a class="nav-link" [routerLink]="['/notifications']"><i class="fa fa-bell" aria-hidden="true"></i></a> -->

        <div class="dropdown show d-inline">
          <a
            class=""
            href="#"
            role="button"
            id="dropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa fa-bell mr-3" aria-hidden="true"></i>
          </a>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <app-notifications></app-notifications>
          </div>
        </div>
      </div>
      <button
        #mainMenuToggle
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        class="collapse navbar-collapse justify-content-center"
        id="navbarSupportedContent"
      >
      <ul class="navbar-nav">
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/general/propList']" (click)="closeMenu()"
            >Search Asset</a
          >
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/pg/pgList']" (click)="closeMenu()"
            >Purchase groups</a
          >
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/auction']" (click)="closeMenu()">Auction</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/lottery']" (click)="closeMenu()">Lottery</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/agents/login']" (click)="closeMenu()">Indicators for agents</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/news']" (click)="closeMenu()">News</a>
        </li>
      </ul>
      </div>
      <div class="d-none d-lg-block" *ngIf="authenticationService.currentUser| async ">
        <div class="dropdown show d-inline">
          <a
            class=""
            href="#"
            role="button"
            id="dropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa fa-user mr-3" aria-hidden="true"></i>
          </a>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a class="dropdown-item fs-12" [routerLink]="['/profile/mydetail']">{{ currentUser.name }}</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item fs-12" [routerLink]="['/profile/mydetail']"
              >Profile</a
            >
            <!-- <a class="dropdown-item fs-12" href="#">News</a> -->
            <a class="dropdown-item fs-12" (click)="logout()" href="#"
              >Logout</a
            >
          </div>
        </div>
        
        <!-- <a class="nav-link" [routerLink]="['/notifications']"><i class="fa fa-bell" aria-hidden="true"></i></a> -->

        <div class="dropdown show d-inline">
          <a
            class=""
            href="#"
            role="button"
            id="dropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa fa-bell mr-3" aria-hidden="true"></i>
          </a>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <app-notifications></app-notifications>
          </div>
        </div>
      </div>
      <div class="d-none d-lg-block" *ngIf="currentUser==null">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a
              class="nav-link"
              style="cursor: pointer"
              (click)="showLogin()"
              >Login</a
            >
          </li>
          <li class="nav-item mt-2">|</li>
          <li class="nav-item">
            <!-- <a
              class="nav-link"
              style="cursor: pointer"
              [routerLink]="['/signup','0']"
              >Signup#</a> -->
              <a
              class="nav-link"
              style="cursor: pointer"
              (click)="showSignUp()"
              >Signup</a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</header>

<header class="landingpage-header">
  <div class="container">
    <nav class="navbar navbar-expand-lg navbar-light justify-content-between">
      <a class="navbar-brand" href="#"><img src="../assets/Images/logo.jpg" class="img-fluid" /></a>
      <div class="mobile-language-container">
        <select [(ngModel)]="selectLang" name="selectLang" (change)="setTransLanguage()"> 
          <option *ngFor="let lang of TransLang" value="{{lang}}">{{ lang }}</option>
        </select>
      </div>
      <!-- <div class="d-lg-block d-none d-md-block">
        <select [(ngModel)]="selectLang" name="selectLang" (change)="setTransLanguage()"> 
          <option *ngFor="let lang of TransLang" value="{{lang}}">{{ lang }}</option>
        </select>
      </div> -->
      <!-- <div class="d-block d-md-none mobile-language-container">
        <select class="form-control" [(ngModel)]="selectLang" name="selectLang" (change)="setTransLanguage()">
          <option *ngFor="let lang of TransLang" value="{{lang}}">{{ lang }}</option>
        </select>
      </div> -->
      <div class="d-block d-md-none" *ngIf="currentUser==null"> 
        <a class=" fs-14"  style="cursor: pointer" (click)="showLogin()">{{ 'header.Login' | translate }}</a> | <a class=" fs-14" style="cursor: pointer" (click)="showSignUp()">{{ 'header.Signup' | translate }}</a>
    </div>
      <div class="d-block d-lg-none" *ngIf="authenticationService.currentUser| async ">
        <div class="dropdown show d-inline">
          <a
            class=""
            href="#"
            role="button"
            id="dropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa fa-user mr-3" aria-hidden="true"></i>
          </a>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a class="dropdown-item fs-12" href="#">{{ currentUser.name }}</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item fs-12" [routerLink]="['/profile/mydetail']"
              >{{ 'header.Profile' | translate }}</a
            >
            <!-- <a class="dropdown-item fs-12" href="#">News</a> -->
            <a class="dropdown-item fs-12" (click)="logout()" href="#"
              >{{ 'header.Logout' | translate }}</a
            >
          </div>
        </div>
        
        <!-- <a class="nav-link" [routerLink]="['/notifications']"><i class="fa fa-bell" aria-hidden="true"></i></a> -->

        <div class="dropdown show d-inline">
          <a
            class=""
            href="#"
            role="button"
            id="dropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa fa-bell mr-3" aria-hidden="true"></i>
          </a>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <app-notifications></app-notifications>
          </div>
        </div>

      </div>
      <button
        #mainMenuToggle
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        class="collapse navbar-collapse justify-content-center"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav">
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/general/propList']"  (click)="closeMenu()">{{ 'header.SearchAsset' | translate }}</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/pg/pgList']" (click)="closeMenu()">{{ 'header.PurchaseGroups' | translate }}</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/auction']" (click)="closeMenu()">{{ 'header.Auction' | translate }}</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/lottery']" (click)="closeMenu()">{{ 'header.Lottery' | translate }}</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/agents/login']" (click)="closeMenu()">{{ 'header.IndicatorsForAgents' | translate }}</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/news']" (click)="closeMenu()">{{ 'header.News' | translate }}</a>
          </li>
          <!-- <li class="nav-item d-block d-lg-none">
            <a
              class="nav-link"
              style="cursor: pointer"
              (click)="showLogin()"
              >{{ 'header.Login' | translate }}</a
            >
          </li>
          <li class="nav-item d-block d-lg-none">
              <a
              class="nav-link"
              style="cursor: pointer"
              (click)="showSignUp()"
              >{{ 'header.Signup' | translate }}</a>
          </li> -->
        </ul>
      </div>
      <div class="d-none d-lg-block" *ngIf="authenticationService.currentUser| async ">
        <div class="dropdown show d-inline">
          <a
            class=""
            href="#"
            role="button"
            id="dropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa fa-user mr-3" aria-hidden="true"></i>
          </a>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a class="dropdown-item fs-12" [routerLink]="['/profile/mydetail']">{{ currentUser.name }}</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item fs-12" [routerLink]="['/profile/mydetail']"
              >{{ 'header.Profile' | translate }}</a>
            <!-- <a class="dropdown-item fs-12" href="#">News</a> -->
            <a class="dropdown-item fs-12" (click)="logout()" href="#"
              >{{ 'header.Logout' | translate }}</a>
          </div>
        </div>
        
        <!-- <a class="nav-link" [routerLink]="['/notifications']"><i class="fa fa-bell" aria-hidden="true"></i></a> -->

        <div class="dropdown show d-inline">
          <a
            class=""
            href="#"
            role="button"
            id="dropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa fa-bell mr-3" aria-hidden="true"></i>
          </a>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <app-notifications></app-notifications>
          </div>
        </div>
      </div>
      <div class="d-none d-lg-block" *ngIf="currentUser==null">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a
              class="nav-link fs-18"
              style="cursor: pointer"
              (click)="showLogin()"
              >{{ 'header.Login' | translate }}</a
            >
          </li>
          <li class="nav-item mt-2">|</li>
          <li class="nav-item">
            <!-- <a
              class="nav-link"
              style="cursor: pointer"
              [routerLink]="['/signup','0']"
              >Signup#</a> -->
              <a
              class="nav-link fs-18"
              style="cursor: pointer"
              (click)="showSignUp()"
              >{{ 'header.Signup' | translate }}</a>
          </li>
        </ul>
      </div>

    </nav>
  </div>
</header>
<!-- <div class="d-block d-md-none mobile-language-container">
  <div class="row">
    <div class="col-12">
      <select class="form-control" [(ngModel)]="selectLang" name="selectLang" (change)="setTransLanguage()">
        <option *ngFor="let lang of TransLang" value="{{lang}}">{{ lang }}</option>
      </select>
    </div>
  </div>
</div> -->
<div class="container" style="margin: 10px 10px 60px 10px !important; Max-width:98% !important; direction: ltr;">
  <router-outlet></router-outlet>
</div>
<footer class="navbar fixed-bottom" *ngIf="useFooter==1" >
  <div class="container" >
        <div class="d-md-flex justify-content-md-between text-center w-100">
      <div>
        <ul>
          <li><a href="#">{{ 'footer.AboutUs' | translate }}</a></li>
          <li><a href="#">{{ 'footer.ContactUs' | translate }}</a></li>
          <li><a [routerLink]="['/terms']" >{{ 'footer.TermsOfUse' | translate }}</a></li>
        </ul>
      </div>
      <div>
        <a href="https://www.facebook.com/Rem-global-102143498940214"> <i class="fa fa-facebook-official mr-2" aria-hidden="true"></i></a>
        <a href="https://www.instagram.com/rem_global/"><i class="fa fa-instagram mr-2" aria-hidden="true"></i></a>
        <a href="https://www.linkedin.com/company/remglobal/?viewAsMember=true"><i class="fa fa-linkedin mr-2" aria-hidden="true"></i></a>
      </div>
    </div>
  </div>
</footer>
<footer class="navbar fixed-bottom landingpage-footer" *ngIf="useFooter==0"  >
  <div class="container">
    <div class="m-auto">
        <ul class="footer-menu">
          <li><a href="#">{{ 'footer.AboutUs' | translate }}</a></li>
          <li><a href="#">{{ 'footer.ContactUs' | translate }}</a></li>
          <li><a [routerLink]="['/terms']" >{{ 'footer.TermsOfUse' | translate }}</a></li>
        </ul>
    </div>
    <div class="m-auto">
      <a href="https://www.facebook.com/Rem-global-102143498940214"> <i class="fa fa-facebook-official mr-2" aria-hidden="true"></i></a>
      <a href="https://www.instagram.com/rem_global/"><i class="fa fa-instagram mr-2" aria-hidden="true"></i></a>
      <a href="https://www.linkedin.com/company/remglobal/?viewAsMember=true"><i class="fa fa-linkedin mr-2" aria-hidden="true"></i></a>
    </div>
  </div>
</footer>


<jw-modal id="login" (onClosed)="onModalClosed($event)">
  <app-login></app-login>
</jw-modal>
<jw-modal id="signup" (onClosed)="onModalClosed($event)">
<app-sign-up></app-sign-up>
</jw-modal>